import React, { useState } from 'react';
import _ from 'lodash';
import Promise from 'bluebird';
import Parse from 'parse';
import { validEmail } from 'shared/models/user';
import FormField from 'scy/FormField';
import { Warning } from 'scy/Warning';
import { LoadingButton, ConfirmButton, BUTTON_CLASSES } from 'scy/buttons';
import { Paragraph } from 'scy/text';
import HR from 'scy/HR';
import { flex, flex1 } from 'scy/flex.mod.scss';
import { textLeft } from 'scy/utils.mod.scss';
import { inlineBlock } from 'scy/display.mod.scss';
import margin from 'scy/margin.mod.scss';

function validateEmail(email) {
  if (!validEmail(email)) return 'Email is not valid';
}

function submit(email) {
  return new Promise((resolve, reject) => {
    Parse.User.requestPasswordReset(email, {
      success() {
        resolve();
      },
      error(err) {
        if (err) reject(new Error(err.message));
      }
    });
  });
}

export default function ForgotPasswordForm({ email, showLogin }) {
  const [userEmail, setUserEmail] = useState(email);
  const [success, setSuccess] = useState(false);
  const [asyncError, setAsyncError] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  function validateFields() {
    let errors = {};
    errors.email = validateEmail(userEmail) || null;

    setErrors(errors);

    if (_.some(errors)) return Promise.reject(new Error());
    return Promise.resolve();
  }

  function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setAsyncError(null);
    setSuccess(false);

    validateFields()
      .then(() => submit(userEmail))
      .then(() => setSuccess(true))
      .catch(({ message }) => {
        setLoading(false);
        setAsyncError(message);
      });
  }

  return success ? (
    <Success email={userEmail} showLogin={showLogin} />
  ) : (
    <form onSubmit={handleSubmit} className={textLeft}>
      {asyncError && <Warning>{asyncError}</Warning>}
      <FormField
        id="user-email"
        name="email"
        labelText="Email"
        inputType="email"
        initialValue={userEmail}
        onChange={setUserEmail}
        validate={email => validateEmail(email)}
        error={errors.email}
      />
      <div className={flex}>
        <LoadingButton
          Button={ConfirmButton}
          type="submit"
          className={flex1}
          disabled={loading}
          loading={loading}
        >
          Reset Password
        </LoadingButton>
      </div>
    </form>
  );
}

function Success({ email, showLogin }) {
  function returnToLogin(e) {
    if (showLogin) {
      e.preventDefault();
      showLogin();
    }
  }

  return (
    <>
      <HR className={margin.bottom_md} />
      <Paragraph marginClass={`${margin.top_0} ${margin.bottom_md}`}>
        A password reset link has been sent to: <br />
        {email}
      </Paragraph>
      <div className={margin.bottom_md}>
        <a
          href="/login"
          className={`${inlineBlock} ${BUTTON_CLASSES.primary}`}
          onClick={returnToLogin}
        >
          Continue to Login
        </a>
      </div>
    </>
  );
}
